import { arrayOf } from 'prop-types'
import { doorPropType } from './door-prop-type'

/**
 * @typedef {Door[]} DoorStatusDataHistory
 */

export const doorStatusDataHistoryPropType = arrayOf(doorPropType)
